import * as React from 'react';
import { SearchOutlined } from '@ant-design/icons';

import './SearchBar.css';

type SearchBarProps = React.HTMLProps<HTMLInputElement>;

export const SearchBar: React.FunctionComponent<SearchBarProps> = (props) => {
  return (
    <div className='search-bar'>
      <SearchOutlined />
      <input
        type='text'
        placeholder='Leita eftir titli (eða merki með forskeytinu „merki:“)'
        className='search-bar-input'
        {...props}
      />
    </div>
  );
};

export default SearchBar;
